import { Category } from '@cabukaka/types'
import { CategoriesList } from '../../shared/categories/CategoriesList'

interface SuggestionCategoriesProps {
 categories: Category[]
}

export default function SuggestionCategories({categories}: SuggestionCategoriesProps) {
    return (
        <div className="border-t border-gray-100 bg-white">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">

                <div className="flex items-end justify-between mb-8">
                    <div>
                        <p className="text-xs font-semibold text-orange-500 uppercase tracking-widest mb-1">Exploration</p>
                        <h2 className="text-2xl font-bold text-gray-900">Vous pourriez aussi aimer</h2>
                    </div>
                </div>

               <CategoriesList
                 categories={categories}
                 layout="horizontal-list"
               />
            </div>
        </div>
    )
}
